import IPage from "../../../interfaces/page"
import ProjectsComponent from "../../Components/Projects/Projects.component"
import MainLayout from "../../layouts/Main/Main.layout"


const ProjectsPage: React.FC<IPage> = () => {
    return <MainLayout component={ProjectsComponent}></MainLayout>
}

export default ProjectsPage